module.exports = __webpack_public_path__ + "img/u3.63d91a6b.png";